import * as React from 'react';
import { IgcCardComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container component that wraps different elements related to a single subject.
 * The card component provides a flexible container for organizing content such as headers,
 * media, text content, and actions.
 * @slot  - Renders the card content. Typically contains igc-card-header, igc-card-media, igc-card-content, and igc-card-actions.
 * @class
 */
export const IgrCard = /* @__PURE__ */ createComponent({
  tagName: 'igc-card',
  displayName: 'IgrCard',
  elementClass: Component,
  react: React,
});

export type IgrCard = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCardModule = Component;
